module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-torino.svg?40f392ae7e37c840c7c5cd13f385ade0";